import { useRef } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { Footer } from '../../components/magic-ui-pro/Footer';
import { StickyHeader } from '../../components/magic-ui-pro/StickyHeader';
import ScrollContainerContext from '../../contexts/ScrollContainerContext';

// ----------------------------------------------------------------------

export default function HomeLayout() {
  const { pathname } = useLocation();
  const containerRef = useRef(null);
  const hideHeaderRoutes = new Set([
    '/getStarted',
    '/getstarted',
    '/get-started',
    '/signup',
    '/sign-up',
    '/register',
  ]);
  const shouldHideHeader = hideHeaderRoutes.has(pathname);

  return (
    <ScrollContainerContext.Provider value={containerRef}>
      <div className="flex flex-col h-full">
        <main
        ref={containerRef}
        className="h-[100vh] w-full overflow-y-auto"
        style={{overflowY:'auto'}}
      >
        {!shouldHideHeader && <StickyHeader containerRef={containerRef} />}
        <div className="w-full min-h-[100vh]">
        <Outlet/>
        </div>
        <Footer />
      </main>
      </div>
    </ScrollContainerContext.Provider>
  );
}
